import { memo } from "react";
import { formatScorecardPeriod } from "../helpers";
import { LOGO } from "../../../utils/constants/images";
import { Loader } from "../../../components";

function ScorecardHistory({
  scorecardHistory,
  historyError,
  isHistoryLoading,
  historySelection,
  isViewingHistory,
  currentPeriodKpiDataIds,
  selectedUserName,
  onSelect,
}) {
  return (
    <section className="scorecard-history-section" aria-label="Scorecard history">
      {isHistoryLoading && <Loader content="Loading scorecard history" />}

      {!isHistoryLoading && historyError && (
        <p className="scorecard-history-message">{historyError}</p>
      )}

      {!historyError && !isHistoryLoading && scorecardHistory.length === 0 && (
        <p className="scorecard-history-message">No scorecard history has been stored yet.</p>
      )}

      {!historyError && !isHistoryLoading && scorecardHistory.length > 0 && (
        <>
        <h4 className="scorecard-history-title"><img src={LOGO} alt="" className="scorecard-history-icon" /> {selectedUserName ? `${selectedUserName} ` : ""}Scorecards</h4>
        <div className="scorecard-history-list">
          
          {scorecardHistory.map((historyItem) => {
            const isSelected = historySelection.selectedId === historyItem.kpiDataId;
            const isCurrentRecord = !isViewingHistory && Boolean(currentPeriodKpiDataIds?.has(historyItem.kpiDataId));

            return (
              <button
                key={historyItem.kpiDataId}
                type="button"
                className={`scorecard-history-card ${isSelected ? "selected" : ""} ${isCurrentRecord ? "current" : ""}`}
                onClick={() => onSelect(historyItem)}
                disabled={historySelection.loading && isSelected}
              >
                <span className="scorecard-history-period">{formatScorecardPeriod(historyItem.month, historyItem.year)}  {isCurrentRecord && <span className="band-badge passed">Current</span>}</span>
               
                {historyItem.centreName && <span className="scorecard-history-centre">{historyItem.centreName}</span>}
                <span className="scorecard-history-email">{historyItem.employeeEmail}</span>
                <span className={`scorecard-history-meta ${historyItem.goalCount > 0 ? "has-goals" : "no-goals"}`}>
                  {historyItem.goalCount > 0 ? `${historyItem.goalCount} focus note${historyItem.goalCount > 1 ? "s" : ""} saved` : "No focus notes"}
                </span>
              </button>
            );
          })}
        </div>
        </>
      )}
    </section>
  );
}

export default memo(ScorecardHistory);
